import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.is-array.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.number.is-nan.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.to-string.js';
import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Modal as Modal$1 } from '@mui/base/Modal';
import Fade from '@mui/material/Fade';
import classNames from 'classnames';
import { ArrowLeftIcon, CloseLargeIcon } from '@cognite/cogs-icons';
import { getNumericCssVariable, getThemeClassNames } from '@cognite/cogs-utils';
import { Button } from '../button/button.js';
import { useConfigContextLoose } from '../config-provider/config-provider.js';

// Gets value of "--cogs-transition-time" variable
var transitionTimeInMs = getNumericCssVariable('--transition-time');
var cogsTransitionTimeInMs = Number.isNaN(transitionTimeInMs) ? 260 : transitionTimeInMs;
var Dialog = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var inProp = _ref["in"],
    className = _ref.className,
    children = _ref.children;
  return jsx(CSSTransition, {
    "in": inProp,
    timeout: cogsTransitionTimeInMs,
    classNames: "cogs-modal",
    appear: true,
    unmountOnExit: true,
    children: jsx("div", {
      className: className,
      ref: ref,
      tabIndex: -1,
      children: children
    })
  });
});
var Backdrop = function Backdrop(_ref2) {
  var inProp = _ref2["in"],
    onClick = _ref2.onClick;
  return jsx(Fade, {
    "in": inProp,
    timeout: cogsTransitionTimeInMs,
    easing: "linear",
    unmountOnExit: true,
    children: jsx("div", {
      "data-testid": "cogs-modal-backdrop",
      className: "cogs-v10 cogs-modal-backdrop",
      onClick: onClick
    })
  });
};
var Modal = function Modal(_ref3) {
  var additionalActions = _ref3.additionalActions,
    _ref3$ariaLabelCloseB = _ref3.ariaLabelCloseButton,
    ariaLabelCloseButton = _ref3$ariaLabelCloseB === undefined ? 'Close' : _ref3$ariaLabelCloseB,
    _ref3$ariaLabelHeader = _ref3.ariaLabelHeaderBackButton,
    ariaLabelHeaderBackButton = _ref3$ariaLabelHeader === undefined ? 'Go back' : _ref3$ariaLabelHeader;
    _ref3.ariaLabelHeader;
    var cancelButtonProps = _ref3.cancelButtonProps,
    _ref3$cancelText = _ref3.cancelText,
    cancelText = _ref3$cancelText === undefined ? 'Cancel' : _ref3$cancelText,
    children = _ref3.children,
    className = _ref3.className,
    _ref3$closable = _ref3.closable,
    closable = _ref3$closable === undefined ? true : _ref3$closable,
    _ref3$destructive = _ref3.destructive,
    destructive = _ref3$destructive === undefined ? false : _ref3$destructive,
    getContainer = _ref3.getContainer,
    _ref3$hideFooter = _ref3.hideFooter,
    hideFooter = _ref3$hideFooter === undefined ? false : _ref3$hideFooter,
    _ref3$hidePaddings = _ref3.hidePaddings,
    hidePaddings = _ref3$hidePaddings === undefined ? false : _ref3$hidePaddings,
    icon = _ref3.icon,
    okButtonProps = _ref3.okButtonProps,
    okDisabled = _ref3.okDisabled,
    _ref3$okText = _ref3.okText,
    okText = _ref3$okText === undefined ? 'OK' : _ref3$okText,
    onBack = _ref3.onBack,
    _ref3$onCancel = _ref3.onCancel,
    onCancel = _ref3$onCancel === undefined ? function () {} : _ref3$onCancel,
    _ref3$onOk = _ref3.onOk,
    onOk = _ref3$onOk === undefined ? function () {} : _ref3$onOk,
    _ref3$showBorders = _ref3.showBorders,
    showBorders = _ref3$showBorders === undefined ? false : _ref3$showBorders,
    _ref3$size = _ref3.size,
    size = _ref3$size === undefined ? 'medium' : _ref3$size,
    subtitle = _ref3.subtitle,
    title = _ref3.title,
    _ref3$visible = _ref3.visible,
    visible = _ref3$visible === undefined ? false : _ref3$visible,
    _ref3$placement = _ref3.placement,
    placement = _ref3$placement === undefined ? 'center' : _ref3$placement,
    inverted = _ref3.inverted,
    themeProps = _ref3.themeProps,
    _ref3$disableEnforceF = _ref3.disableEnforceFocus,
    disableEnforceFocus = _ref3$disableEnforceF === undefined ? false : _ref3$disableEnforceF,
    _ref3$hideHeaderClose = _ref3.hideHeaderCloseButton,
    hideHeaderCloseButton = _ref3$hideHeaderClose === undefined ? false : _ref3$hideHeaderClose;
  var isSizeFullScreen = size === 'full-screen';
  var isSizeXSmall = size === 'x-small';
  var hasAdditionalActions = !isSizeXSmall && additionalActions;
  var _useConfigContextLoos = useConfigContextLoose(),
    getOverlayContainer = _useConfigContextLoos.getOverlayContainer;
  var modalFooterClassName = classNames('cogs-v10', 'cogs-modal-footer', hasAdditionalActions && 'cogs-modal-footer--with-additional-actions');
  var getContainerLocal = getContainer !== null && getContainer !== undefined ? getContainer : getOverlayContainer === null || getOverlayContainer === undefined ? undefined : getOverlayContainer();
  var handleOkClick = function handleOkClick() {
    if (closable && onOk) onOk();
  };
  var handleCancelClick = function handleCancelClick(reason) {
    if (closable && onCancel) onCancel(reason);
  };
  var onClick = function onClick(evt) {
    evt.stopPropagation();
  };
  function renderAdditionalActions() {
    if (Array.isArray(additionalActions)) {
      if (additionalActions.length > 1) {
        return additionalActions.map(function (_a) {
          var key = _a.key,
            otherProps = __rest(_a, ["key"]);
          return jsx(Button, Object.assign({
            type: "ghost"
          }, otherProps), key);
        });
      }
      return jsx(Button, Object.assign({
        type: "ghost"
      }, additionalActions[0]));
    }
    return jsx(Button, Object.assign({
      type: "ghost"
    }, additionalActions));
  }
  var footer = jsxs("div", {
    className: modalFooterClassName,
    children: [hasAdditionalActions && jsx("div", {
      className: "cogs-v10 cogs-modal-footer-buttons",
      children: renderAdditionalActions()
    }), jsxs("div", {
      className: "cogs-v10 cogs-modal-footer-buttons",
      children: [jsx(Button, Object.assign({
        onClick: function onClick() {
          return handleCancelClick('cancelClick');
        },
        type: "ghost",
        size: isSizeXSmall ? 'small' : 'medium',
        className: "cogs-v10 cogs-modal-cancel-button"
      }, cancelButtonProps || {}, {
        children: cancelText
      })), jsx(Button, Object.assign({
        disabled: okDisabled,
        type: destructive ? 'destructive' : 'primary',
        size: isSizeXSmall ? 'small' : 'medium',
        onClick: handleOkClick,
        className: "cogs-v10 cogs-modal-ok-button"
      }, okButtonProps || {}, {
        children: okText
      }))]
    })]
  }, "modal-footer");
  var headerIcon = onBack && jsx(Button, {
    type: "ghost",
    icon: jsx(ArrowLeftIcon, {}),
    "aria-label": ariaLabelHeaderBackButton,
    onClick: onBack
  }) || icon;
  var modalHeaderClassName = classNames('cogs-v10', 'cogs-modal-header', headerIcon && 'cogs-modal-header--with-icon', onBack && 'cogs-modal-header--with-back-button');
  var modalContentClassName = classNames('cogs-v10', 'cogs-modal__content', isSizeXSmall && 'cogs-body-2', isSizeXSmall && 'strong', hidePaddings && 'cogs-modal__content--hide-paddings');
  var closeButton = jsx(Button, {
    className: "cogs-v10 cogs-modal-close-button",
    type: "ghost",
    onClick: function onClick() {
      return handleCancelClick('closeClick');
    },
    "aria-label": ariaLabelCloseButton,
    icon: jsx(CloseLargeIcon, {})
  }, "modal-close-button");
  var extendedChildren = [jsxs("div", {
    className: modalHeaderClassName,
    children: [headerIcon, jsxs("div", {
      id: "cogs-modal-title",
      className: "cogs-v10 cogs-modal-title-container",
      children: [jsx("span", {
        className: "cogs-v10 cogs-modal-title",
        children: title
      }), subtitle && jsx("span", {
        className: "cogs-v10 cogs-modal-subtitle",
        children: subtitle
      })]
    })]
  }, "modal-header"), !hideHeaderCloseButton && closable && closeButton, jsx("div", {
    className: "cogs-v10 cogs-modal__content-container",
    "data-test-id": "cogs-modal__content-container",
    children: jsx("div", {
      id: "cogs-modal__content",
      className: modalContentClassName,
      children: children
    }, "modal-content")
  }, "modal-content-container"), !hideFooter && footer].filter(function (element) {
    return Boolean(element);
  });
  var extendedClassName = classNames.apply(undefined, ['cogs-v10', 'cogs-modal', "cogs-modal--" + size, showBorders && 'cogs-modal--show-borders', !closable && 'cogs-modal--not-closable', hideFooter && 'cogs-modal--no-footer', isSizeXSmall && 'cogs-modal--x-small', isSizeFullScreen && 'cogs-modal--full-screen', "cogs-modal--placement-" + placement].concat(getThemeClassNames(inverted, themeProps), [className]));
  return jsx(Modal$1, {
    onClick: onClick,
    "aria-describedby": "cogs-modal__content",
    "aria-labelledby": isSizeXSmall ? 'cogs-modal__content' : 'cogs-modal-title',
    slots: {
      backdrop: Backdrop
    },
    slotProps: {
      backdrop: {
        "in": visible,
        onClick: function onClick() {
          return handleCancelClick('backdropClick');
        }
      }
    },
    container: getContainerLocal,
    keepMounted: true,
    disableEscapeKeyDown: !closable,
    onClose: function onClose(_, reason) {
      return handleCancelClick(reason);
    },
    open: visible,
    disableEnforceFocus: disableEnforceFocus,
    children: jsx(Dialog, {
      "in": visible,
      className: extendedClassName,
      children: extendedChildren
    })
  });
};

export { Modal };
